var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 16c0 .876-1.124 2-2 2-1.876 0-3-1.124-3-2 0-1.876 1.124-3 3-3h2v3zm1-1c0-.902 1.124-2 3-2 .876 0 2 1.098 2 2v7c0 .902-1.124 2-2 2-1.876 0-3-1.098-3-2v-7z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5C7.124 5 6 3.876 6 3c0-1.876 1.124-3 3-3 .876 0 2 1.124 2 2v3H9zm0 1c.902 0 2 1.124 2 3 0 .876-1.098 2-2 2H2c-.902 0-2-1.124-2-3 0-.876 1.098-2 2-2h7z",
    fill: "#36C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9c0-1.876 1.124-3 3-3 .876 0 2 1.124 2 3 0 .876-1.124 2-2 2h-3V8v1zm-1 0c0 .902-1.124 2-2 2-1.876 0-3-1.098-3-2V2c0-.902 1.124-2 3-2 .876 0 2 1.098 2 2v7z",
    fill: "#2EB67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19c.876 0 2 1.124 2 3 0 .876-1.124 2-2 2-1.876 0-3-1.124-3-2v-3h3zm-1-1c-.902 0-2-1.124-2-2 0-1.876 1.098-3 2-3h7c.902 0 2 1.124 2 3 0 .876-1.098 2-2 2h-7z",
    fill: "#ECB22D"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default ForwardRef;